import React from 'react';
import { useTranslation } from 'react-i18next';
import { CriterionRow } from '@/components/PreschoolEvaluationModal/CriterionRow';
import type { PreschoolDiscipline } from '@/types/preschool';
import { linkifyText } from '@/utils/html';

interface Props {
  discipline: PreschoolDiscipline;
}

export const DisciplineCard: React.FC<Props> = ({ discipline }) => {
  const { t } = useTranslation();
  const { orderNumber, name, teacherTasks, criteriaSubmissions } = discipline;

  return (
    <div className="flex flex-col gap-4 rounded-xl border border-transparent bg-card p-4 shadow-card contrast:border-border md:gap-5 md:pt-6">
      <h3 className="text-subhead-14 border-b border-divider pb-4 text-foreground md:text-callout-16 md:pb-6">
        {`${orderNumber}. ${name}`}
      </h3>

      {criteriaSubmissions.map((criterion, index) => (
        <React.Fragment key={criterion.orderNumber}>
          {index > 0 && <div className="h-px bg-divider" />}
          <CriterionRow
            criterion={criterion}
            disciplineOrderNumber={orderNumber}
          />
        </React.Fragment>
      ))}

      {teacherTasks && (
        <>
          <div className="h-px bg-divider" />
          <div className="flex flex-col gap-2">
            <p className="text-subhead-14 text-foreground md:text-callout-16">
              {t('preschoolEvaluation.teacherActivity')}
            </p>
            <p
              className="rich-text text-body-14 whitespace-pre-line text-subtle-foreground"
              dangerouslySetInnerHTML={{ __html: linkifyText(teacherTasks) }}
            />
          </div>
        </>
      )}
    </div>
  );
};
